/* global $, query_string, data */
import Table from 'bam-node-savant-table/table'

import { appSettings } from 'bam-node-baseball-savant/leaderboard/appSettings'
import { guff } from 'bam-node-baseball-savant/utils/guff'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'runs'
const sortClass = 'column-sort'

const { group, sortDir } = query_string

const isBatter = !group || group === 'Batter' || group === 'Batter Team'
const defaultSortDir = isBatter ? 'desc' : 'asc'
const initialSortDir = ['asc', 'desc'].includes(sortDir)
    ? sortDir
    : defaultSortDir

if (query_string.type) {
    $('#ddlType').val(query_string.type).attr('selected', true)
}

$('#lblType').html(`Stat Type: ${$('#ddlType option:selected').text()}`)

if (query_string.group) {
    $('#ddlPlayerType').val(query_string.group).attr('selected', true)
    $('#lblPlayerType').html($('#ddlPlayerType option:selected').text())
}

if (query_string.year) {
    $('#ddlQualified').val(query_string.year).attr('selected', true)
    $('#lblQualified').html(
        `Qualified Years: ${$('#ddlQualified option:selected').text()}`
    )
}

$(document).ready(() => {
    $('#ddlQualified').change(() => {
        $('#lblQualified').html(
            `Qualified Years: ${$('#ddlQualified option:selected').text()}`
        )
    })
    $('form').submit(false)

    if (data && data.length > 0) {
        let type = $('#ddlType').val()
        if (query_string.type) {
            type = query_string.type
        }
        createTable(type)
    } else {
        $('#NoData').html('<h1>No Data Found.</h2>')
    }

    $('#btnUpdate').click(() => {
        window.location.href = populateUrl()
    })

    $('#btnCSV').click(() => {
        window.location.href = `${populateUrl()}&csv=true`
    })

    $('#ddlType').change(() => {
        $('#lblType').text(`Stat Type: ${$('#ddlType option:selected').text()}`)
    })

    $('#ddlPlayerType').change(() => {
        $('#lblPlayerType').text($('#ddlPlayerType option:selected').text())
    })
})

function displayFnFactory(type, isDiff = false) {
    return (val) => guff(val, type, { isDiff })
}

function createHeaders(type) {
    const yearHeaders = appSettings.SETTINGS_YEAR_TO_YEAR.years.reduce(
        (acc, year, i) => {
            const prevYear = year - 1
            if (i === 0) {
                acc.push({
                    name: year,
                    field: `${type}_${year}`,
                    headerClass: 'th-component-header border-left',
                    fieldClass: 'tr-data border-left',
                    type: 'number',
                    displayFn: displayFnFactory(type),
                })
            }

            acc.push({
                name: '+/-',
                field: `${type}_diff_${prevYear}`,
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left color-cell',
                type: 'number',
                displayFn: displayFnFactory(type, true),
            })

            acc.push({
                name: prevYear,
                field: `${type}_${prevYear}`,
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                type: 'number',
                displayFn: displayFnFactory(type),
            })

            return acc
        },
        []
    )

    return yearHeaders
}

function createTable(type) {
    const dataLoad = data

    const extraHeaders = createHeaders(type)

    const headers = [
        {
            name: 'Player',
            field: 'href',
            customSortField: 'name_display_last_first',
            headerClass: 'th-component-header align-left table-static-column',
            fieldClass: 'tr-data align-left table-static-column',
            photo:
                query_string.group && query_string.group.indexOf('Team') > -1
                    ? '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />'
                    : '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
            photoId: 'entity_id',
        },
        ...extraHeaders,
    ]

    const width = $(`#${tableDivId}`).outerWidth()
    let repeatHeaders = false
    if (width <= 768) {
        repeatHeaders = 15
    }

    const currentYear =
        query_string.year || appSettings.SETTINGS_YEAR_TO_YEAR.year - 1
    const defaultSort = `${type}_diff_${currentYear}`
    let sortVal = query_string.sort || defaultSort

    if (!Number.isNaN(Number(sortVal))) {
        sortVal =
            headers[Number(sortVal)].customSortField ||
            headers[Number(sortVal)].field
    }

    // eslint-disable-next-line no-new
    new Table({
        id: tableDivId,
        repeatHeader: repeatHeaders,
        headers,
        data: dataLoad,
        defaultSort: sortVal,
        defaultSortDirection: initialSortDir,
        sortClass,
        showRank: true,
        sortCallback(column, idx, { state }) {
            if (column.includes('_diff_')) {
                const el = document.getElementById(`${tableDivId}_th-${idx}`)

                if (el) {
                    styleColumns(el)
                }
            }
            const url = populateUrl(column, state)
            window.history.replaceState('', '', url)
        },
    })

    if (sortVal.includes('_diff_')) {
        const el = document.querySelector(`#${tableDivId} th.${sortClass}`)
        styleColumns(el)
    }
}

function styleColumns(diffEl) {
    // https://stackoverflow.com/a/40052000e
    const tableIndex = [...diffEl.parentNode.children].findIndex(
        (c) => c === diffEl
    )

    // Unneccessary because the table just gets rewritten
    // ;[...el.parentNode.children].forEach((c) => {
    //     c.style.background = ''
    // })

    const previous = diffEl.previousElementSibling
    const next = diffEl.nextElementSibling

    const border = '3px solid black'
    previous.style.backgroundColor = '#7db6bb'
    previous.style.color = '#fff'
    previous.style.borderLeft = border
    next.style.backgroundColor = '#7db6bb'
    next.style.borderRight = border
    next.style.color = '#fff'
    // These get over written every time we sort, so need to reset.
    ;[
        ...document.querySelectorAll(
            `#${tableDivId} .default-table-row td:nth-child(${tableIndex})` // css is 1 indexed, so this is prev
        ),
    ].forEach((td) => {
        // eslint-disable-next-line no-param-reassign
        td.style.borderLeft = border
    })
    ;[
        ...document.querySelectorAll(
            `#${tableDivId} .default-table-row td:nth-child(${tableIndex + 2})` // css is 1 indexed, so this is 1 after
        ),
    ].forEach((td) => {
        // eslint-disable-next-line no-param-reassign
        td.style.borderRight = border
    })
}

function populateUrl(sortColumn, sortDirection) {
    const parameters = {
        type: $('#ddlType').val(),
        group: $('#ddlPlayerType').val(),
        year: $('#ddlQualified').val(),
    }

    // THESE ARE NAMED SLIGHTLY DIFFERENTLY THAN PITCH-TEMPO. Sorry future me.
    if (sortColumn) {
        parameters.sort = sortColumn
    }
    if (sortDirection) {
        parameters.sortDir = sortDirection
    }

    const urlParams = new URLSearchParams(parameters)

    return `/leaderboard/statcast-year-to-year?${urlParams.toString()}`
}

window.addEventListener('scroll', () => {
    if (!ticking && data.length) {
        window.requestAnimationFrame(() => {
            checkHeaderPosition(tableDivId)
            ticking = false
        })

        ticking = true
    }
})

function checkHeaderPosition(divId) {
    const scrollPosY = window.scrollY
    const posTop = $(`#${divId}`).offset().top
    const height = $(`#${divId} table thead`).height()
    if (!isFixedHeaderShowing && posTop < scrollPosY) {
        isFixedHeaderShowing = true
        addStaticHeader(divId)
    } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
        $(`#${divId} table thead`).removeClass('fixed-header')
        isFixedHeaderShowing = false
    }
}

function addStaticHeader(divId) {
    const width = $(`#${divId}`).outerWidth()
    // $(".tr-component-row th").removeClass("column-sort");

    if (width && width > 767) {
        let tableCell = 0

        // Set TH Width before applying fixed-header
        $('.default-table-row')
            .first()
            .children('td')
            .each(function handleEach() {
                const outerWidth = $(this).outerWidth()
                $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                    'width',
                    outerWidth
                )
                tableCell += 1
            })

        $(`#${divId} table thead`).addClass('fixed-header')
        tableCell = 0

        // Set TD Width before applying fixed-header
        $('.tr-component-row')
            .children('th')
            .each(function handleEach() {
                const outerWidth = $(this).outerWidth()
                $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                    'width',
                    outerWidth
                )
                tableCell += 1
            })
    }
}

window.addEventListener('resize', () => {
    if (isFixedHeaderShowing) {
        addStaticHeader(tableDivId)
    }
})
